import { NeumaticoMatricula } from '../../../../../../common/types/Neumatico'
import { normalizeMatriculaForDev } from './neumaticosDevConfig'

function tallerNeumatico(
  matricula: string,
  partial: Pick<
    NeumaticoMatricula,
    'ancho' | 'serie' | 'llanta' | 'ic' | 'cv'
  > & { id_vehiculo?: number }
): NeumaticoMatricula {
  return {
    id_matricula_neumaticos: partial.id_vehiculo ?? 0,
    cliente_navision: 'DEV',
    cod_producto: 'DEV-TALLER',
    cantidad: 4,
    matricula,
    ancho: partial.ancho,
    serie: partial.serie,
    llanta: partial.llanta,
    ic: partial.ic,
    cv: partial.cv,
    marca: 'Michelin',
    fecha: '2025-01-01',
    runflat: false,
    allseason: false,
    verano: true,
    invierno: false,
    posicion: 'ambos',
  }
}

/** Medida de taller por matrícula (cuando no depende del modelo AMI). */
const TALLER_POR_MATRICULA: Record<string, NeumaticoMatricula> = {
  '4981KTN': tallerNeumatico('4981KTN', {
    ancho: '205',
    serie: '55',
    llanta: '16',
    ic: '91',
    cv: 'V',
  }),
  /** Varias AMI; solo debe quedar 205/55 R16 91V del taller */
  '7524MTR': tallerNeumatico('7524MTR', {
    ancho: '205',
    serie: '55',
    llanta: '16',
    ic: '91',
    cv: 'V',
  }),
}

/** 0860FFL: medida de taller distinta según modelo elegido */
const TALLER_POR_VEHICULO: Record<number, NeumaticoMatricula> = {
  90101: tallerNeumatico('0860FFL', {
    id_vehiculo: 90101,
    ancho: '205',
    serie: '55',
    llanta: '16',
    ic: '91',
    cv: 'V',
  }),
  90102: tallerNeumatico('0860FFL', {
    id_vehiculo: 90102,
    ancho: '225',
    serie: '45',
    llanta: '17',
    ic: '94',
    cv: 'W',
  }),
}

export function getDevTallerNeumatico(
  matricula: string,
  idVehiculo: number
): NeumaticoMatricula | null {
  const byVehicle = TALLER_POR_VEHICULO[idVehiculo]
  if (byVehicle) return byVehicle

  const key = normalizeMatriculaForDev(matricula)
  return TALLER_POR_MATRICULA[key] ?? null
}
